import Grid from 'epn-ui/umd/dist/components/Grid';
import BaseContainer from '@base/BaseContainer';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

import { ILayoutProps } from './default';

const ToolsLayout: React.FC<ILayoutProps> = ({ children, isAuth }) => {
    return (
        <>
            <Header isAuth={isAuth} />
            <div className="mt-4 xs:mt-10">
                <BaseContainer>
                    <div className="mb-6 md:hidden">
                        <Sidebar.Mobile />
                    </div>
                    <Grid
                        gutter={[
                            { xs: 8, sm: 16, md: 16, lg: 24, xl: 24 },
                            { xs: 16, sm: 16, md: 16, lg: 24, xl: 24 },
                        ]}
                    >
                        <Grid.Col span={0} xs={0} sm={0} md={6} lg={6} xl={4}>
                            <Sidebar.Desktop />
                        </Grid.Col>
                        <Grid.Col span={24} xs={24} sm={24} md={18} lg={18} xl={20}>
                            {children}
                        </Grid.Col>
                    </Grid>
                </BaseContainer>
            </div>
            <Footer isAuth={isAuth} />
        </>
    );
};

export default ToolsLayout;
